/*
 * Capable Health API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0.3
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.72
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from "../ApiClient";
import IdGeneratePdfBody from '../model/IdGeneratePdfBody';
import InlineResponse2001 from '../model/InlineResponse2001';
import PatientsBody from '../model/PatientsBody';
import PatientsIdBody from '../model/PatientsIdBody';
import PatientsInviteBody from '../model/PatientsInviteBody';

/**
* Patients service.
* @module api/PatientsApi
* @version v0.3
*/
export default class PatientsApi {

    /**
    * Constructs a new PatientsApi. 
    * @alias module:api/PatientsApi
    * @class
    * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
    * default to {@link module:ApiClient#instanc
    e} if unspecified.
    */
    constructor(apiClient) {
        this.apiClient = apiClient || ApiClient.instance;
    }

    /**
     * Callback function to receive the result of the patientsExportCsvGet operation.
     * @callback moduleapi/PatientsApi~patientsExportCsvGetCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Patients export as CSV
     * &lt;h3&gt;   &amp;#128275; Access policy &lt;/h3&gt; &lt;p&gt;You can access this endpoint with the following token types:&lt;/p&gt; &lt;p&gt;&amp;#9989; M2M&amp;nbsp;&amp;nbsp;&amp;nbsp;&amp;nbsp;&amp;#10060; &lt;s&gt;Patient&lt;/s&gt;&amp;nbsp;&amp;nbsp;&amp;nbsp;&amp;nbsp;&amp;#9989; Practitioner&lt;/p&gt; 
     * @param {module:api/PatientsApi~patientsExportCsvGetCallback} callback The callback function, accepting three arguments: error, data, response
     */
    patientsExportCsvGet(callback) {
      
      let postBody = null;

      let pathParams = {
        
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = [];
      let returnType = null;

      return this.apiClient.callApi(
        '/patients/export_csv', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the patientsGet operation.
     * @callback moduleapi/PatientsApi~patientsGetCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * List all Patients
     * &lt;h3&gt;   &amp;#128275; Access policy &lt;/h3&gt; &lt;p&gt;You can access this endpoint with the following token types:&lt;/p&gt; &lt;p&gt;&amp;#9989; M2M&amp;nbsp;&amp;nbsp;&amp;nbsp;&amp;nbsp;&amp;#10060; &lt;s&gt;Patient&lt;/s&gt;&amp;nbsp;&amp;nbsp;&amp;nbsp;&amp;nbsp;&amp;#9989; Practitioner&lt;/p&gt; 
     * @param {Object} opts Optional parameters
     * @param {Number} opts.page Page number (default to <.>)
     * @param {Number} opts.size Page size (default to <.>)
     * @param {Array.<module:model/String>} opts.sortBy Sort results
     * @param {Array.<String>} opts.filters *Note: that the strings are stringified and encoded objects.*  Filter with operators.  | Field          | Operator | | ---------------| ---------| | tags | eq, not_eq, matches, does_not_match, in, not_in | | surgery_date | eq, not_eq, gt, gteq, lt, lteq, in, not_in | | surgery_type | eq, not_eq, matches, does_not_match, in, not_in | | surgery_status | eq, not_eq, matches, does_not_match, in, not_in | | patient_status | eq, not_eq, matches, does_not_match, in, not_in | | epic_mrn | eq, not_eq, matches, does_not_match, in, not_in | | readiness | eq, not_eq, in, not_in | | identity_id | eq, not_eq, matches, does_not_match, in, not_in | | primary_phone_number | eq, not_eq, matches, does_not_match, in, not_in | | id | eq, not_eq, matches, does_not_match, in, not_in | | created_at | eq, not_eq, gt, gteq, lt, lteq, in, not_in | | updated_at | eq, not_eq, gt, gteq, lt, lteq, in, not_in | | external_id | eq, not_eq, matches, does_not_match, in, not_in | | email | eq, not_eq, matches, does_not_match, in, not_in | | type | eq, not_eq, matches, does_not_match, in, not_in | | first_name | eq, not_eq, matches, does_not_match, in, not_in | | middle_name | eq, not_eq, matches, does_not_match, in, not_in | | last_name | eq, not_eq, matches, does_not_match, in, not_in | | patient_number | eq, not_eq, matches, does_not_match, in, not_in | | age | eq, not_eq, gt, gteq, lt, lteq, in, not_in | | cognito_username | eq, not_eq, matches, does_not_match, in, not_in |  Example query value: &#x60;&#x60;&#x60; { &#x27;field&#x27;: &#x27;tags&#x27;, &#x27;operator&#x27;:&#x27;eq&#x27;, &#x27;value&#x27;:&#x27;expected_value&#x27;, } &#x60;&#x60;&#x60;  Example stringified and encoded query value: &#x60;&#x60;&#x60; %7B%22field%22%3A%22%23%7Btags%7D%22%2C%22operator%22%3A%22eq%22%2C%22value%22%3A%22expected_value%22%7D &#x60;&#x60;&#x60;
     * @param {module:model/String} opts.filtersOperator Operator to chain filters
     * @param {String} opts.byFirstName Filter by first name
     * @param {String} opts.byLastName Filter by last name
     * @param {Array.<String>} opts.byEmail Filter by email
     * @param {Number} opts.byAge Filter by age
     * @param {Array.<String>} opts.byTags Filter by tags
     * @param {Array.<String>} opts.byId Filter by id
     * @param {String} opts.byPatientNumber Filter patients by patient number (searches array)
     * @param {String} opts.byPrimaryPhoneNumber Filter by primary phone number
     * @param {module:api/PatientsApi~patientsGetCallback} callback The callback function, accepting three arguments: error, data, response
     */
    patientsGet(opts, callback) {
      opts = opts || {};
      let postBody = null;

      let pathParams = {
        
      };
      let queryParams = {
        'page': opts['page'],'size': opts['size'],'sort_by': this.apiClient.buildCollectionParam(opts['sortBy'], 'csv'),'filters[]': this.apiClient.buildCollectionParam(opts['filters'], 'multi'),'filters_operator': opts['filtersOperator'],'by_first_name': opts['byFirstName'],'by_last_name': opts['byLastName'],'by_email': this.apiClient.buildCollectionParam(opts['byEmail'], 'csv'),'by_age': opts['byAge'],'by_tags': this.apiClient.buildCollectionParam(opts['byTags'], 'csv'),'by_id': this.apiClient.buildCollectionParam(opts['byId'], 'csv'),'by_patient_number': opts['byPatientNumber'],'by_primary_phone_number': opts['byPrimaryPhoneNumber']
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = [];
      let returnType = null;

      return this.apiClient.callApi(
        '/patients', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the patientsIdAvatarPost operation.
     * @callback moduleapi/PatientsApi~patientsIdAvatarPostCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Update a Patient&#x27;s avatar
     * &lt;h3&gt;   &amp;#128275; Access policy &lt;/h3&gt; &lt;p&gt;You can access this endpoint with the following token types:&lt;/p&gt; &lt;p&gt;&amp;#9989; M2M&amp;nbsp;&amp;nbsp;&amp;nbsp;&amp;nbsp;&amp;#9989; Patient&amp;nbsp;&amp;nbsp;&amp;nbsp;&amp;nbsp;&amp;#10060; &lt;s&gt;Practitioner&lt;/s&gt;&lt;/p&gt; 
     * @param {String} id 
     * @param {Object} opts Optional parameters
     * @param {Blob} opts.avatar 
     * @param {module:api/PatientsApi~patientsIdAvatarPostCallback} callback The callback function, accepting three arguments: error, data, response
     */
    patientsIdAvatarPost(id, opts, callback) {
      opts = opts || {};
      let postBody = null;
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling patientsIdAvatarPost");
      }

      let pathParams = {
        'id': id
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        'avatar': opts['avatar']
      };

      let authNames = [];
      let contentTypes = ['multipart/form-data'];
      let accepts = [];
      let returnType = null;

      return this.apiClient.callApi(
        '/patients/{id}/avatar', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the patientsIdDelete operation.
     * @callback moduleapi/PatientsApi~patientsIdDeleteCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * delete a Patient
     * &lt;h3&gt;   &amp;#128275; Access policy &lt;/h3&gt; &lt;p&gt;You can access this endpoint with the following token types:&lt;/p&gt; &lt;p&gt;&amp;#9989; M2M&amp;nbsp;&amp;nbsp;&amp;nbsp;&amp;nbsp;&amp;#10060; &lt;s&gt;Patient&lt;/s&gt;&amp;nbsp;&amp;nbsp;&amp;nbsp;&amp;nbsp;&amp;#10060; &lt;s&gt;Practitioner&lt;/s&gt;&lt;/p&gt; 
     * @param {String} id 
     * @param {module:api/PatientsApi~patientsIdDeleteCallback} callback The callback function, accepting three arguments: error, data, response
     */
    patientsIdDelete(id, callback) {
      
      let postBody = null;
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling patientsIdDelete");
      }

      let pathParams = {
        'id': id
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = [];
      let returnType = null;

      return this.apiClient.callApi(
        '/patients/{id}', 'DELETE',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the patientsIdGeneratePdfPost operation.
     * @callback moduleapi/PatientsApi~patientsIdGeneratePdfPostCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * generate PDF based on template name
     * &lt;h3&gt;   &amp;#128275; Access policy &lt;/h3&gt; &lt;p&gt;You can access this endpoint with the following token types:&lt;/p&gt; &lt;p&gt;&amp;#9989; M2M&amp;nbsp;&amp;nbsp;&amp;nbsp;&amp;nbsp;&amp;#10060; &lt;s&gt;Patient&lt;/s&gt;&amp;nbsp;&amp;nbsp;&amp;nbsp;&amp;nbsp;&amp;#9989; Practitioner&lt;/p&gt; 
     * @param {String} id 
     * @param {Object} opts Optional parameters
     * @param {module:model/IdGeneratePdfBody} opts.body 
     * @param {module:api/PatientsApi~patientsIdGeneratePdfPostCallback} callback The callback function, accepting three arguments: error, data, response
     */
    patientsIdGeneratePdfPost(id, opts, callback) {
      opts = opts || {};
      let postBody = opts['body'];
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling patientsIdGeneratePdfPost");
      }

      let pathParams = {
        'id': id
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = ['application/json'];
      let accepts = [];
      let returnType = null;

      return this.apiClient.callApi(
        '/patients/{id}/generate_pdf', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the patientsIdGet operation.
     * @callback moduleapi/PatientsApi~patientsIdGetCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Retrieve a Patient
     * &lt;h3&gt;   &amp;#128275; Access policy &lt;/h3&gt; &lt;p&gt;You can access this endpoint with the following token types:&lt;/p&gt; &lt;p&gt;&amp;#9989; M2M&amp;nbsp;&amp;nbsp;&amp;nbsp;&amp;nbsp;&amp;#9989; Patient&amp;nbsp;&amp;nbsp;&amp;nbsp;&amp;nbsp;&amp;#9989; Practitioner&lt;/p&gt; 
     * @param {String} id 
     * @param {module:api/PatientsApi~patientsIdGetCallback} callback The callback function, accepting three arguments: error, data, response
     */
    patientsIdGet(id, callback) {
      
      let postBody = null;
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling patientsIdGet");
      }

      let pathParams = {
        'id': id
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = [];
      let returnType = null;

      return this.apiClient.callApi(
        '/patients/{id}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the patientsIdMdiPatientAppGet operation.
     * @callback moduleapi/PatientsApi~patientsIdMdiPatientAppGetCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get Patient App URL
     * &lt;h3&gt;   &amp;#128275; Access policy &lt;/h3&gt; &lt;p&gt;You can access this endpoint with the following token types:&lt;/p&gt; &lt;p&gt;&amp;#10060; &lt;s&gt;M2M&lt;/s&gt;&amp;nbsp;&amp;nbsp;&amp;nbsp;&amp;nbsp;&amp;#9989; Patient&amp;nbsp;&amp;nbsp;&amp;nbsp;&amp;nbsp;&amp;#10060; &lt;s&gt;Practitioner&lt;/s&gt;&lt;/p&gt; 
     * @param {String} id 
     * @param {module:api/PatientsApi~patientsIdMdiPatientAppGetCallback} callback The callback function, accepting three arguments: error, data, response
     */
    patientsIdMdiPatientAppGet(id, callback) {
      
      let postBody = null;
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling patientsIdMdiPatientAppGet");
      }

      let pathParams = {
        'id': id
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = [];
      let returnType = null;

      return this.apiClient.callApi(
        '/patients/{id}/mdi_patient_app', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the patientsIdPatch operation.
     * @callback moduleapi/PatientsApi~patientsIdPatchCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Update a Patient
     * &lt;h3&gt;   &amp;#128275; Access policy &lt;/h3&gt; &lt;p&gt;You can access this endpoint with the following token types:&lt;/p&gt; &lt;p&gt;&amp;#9989; M2M&amp;nbsp;&amp;nbsp;&amp;nbsp;&amp;nbsp;&amp;#9989; Patient&amp;nbsp;&amp;nbsp;&amp;nbsp;&amp;nbsp;&amp;#10060; &lt;s&gt;Practitioner&lt;/s&gt;&lt;/p&gt; 
     * @param {String} id 
     * @param {Object} opts Optional parameters
     * @param {module:model/PatientsIdBody} opts.body 
     * @param {module:api/PatientsApi~patientsIdPatchCallback} callback The callback function, accepting three arguments: error, data, response
     */
    patientsIdPatch(id, opts, callback) {
      opts = opts || {};
      let postBody = opts['body'];
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling patientsIdPatch");
      }

      let pathParams = {
        'id': id
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = ['application/json'];
      let accepts = [];
      let returnType = null;

      return this.apiClient.callApi(
        '/patients/{id}', 'PATCH',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the patientsIdStatusHistoryGet operation.
     * @callback moduleapi/PatientsApi~patientsIdStatusHistoryGetCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/InlineResponse2001>{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * List a Patient&#x27;s status history
     * &lt;h3&gt;   &amp;#128275; Access policy &lt;/h3&gt; &lt;p&gt;You can access this endpoint with the following token types:&lt;/p&gt; &lt;p&gt;&amp;#9989; M2M&amp;nbsp;&amp;nbsp;&amp;nbsp;&amp;nbsp;&amp;#9989; Patient&amp;nbsp;&amp;nbsp;&amp;nbsp;&amp;nbsp;&amp;#9989; Practitioner&lt;/p&gt;
     * @param {String} id
     * @param {module:api/PatientsApi~patientsIdStatusHistoryGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    patientsIdStatusHistoryGet(id, callback) {

      let postBody = null;
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling patientsIdStatusHistoryGet");
      }

      let pathParams = {
        'id': id
      };
      let queryParams = {

      };
      let headerParams = {

      };
      let formParams = {

      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = [InlineResponse2001];

      return this.apiClient.callApi(
        '/patients/{id}/status_history', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the patientsInvitePost operation.
     * @callback moduleapi/PatientsApi~patientsInvitePostCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Invite a Patient
     * &lt;h3&gt;   &amp;#128275; Access policy &lt;/h3&gt; &lt;p&gt;You can access this endpoint with the following token types:&lt;/p&gt; &lt;p&gt;&amp;#9989; M2M&amp;nbsp;&amp;nbsp;&amp;nbsp;&amp;nbsp;&amp;#9989; Patient&amp;nbsp;&amp;nbsp;&amp;nbsp;&amp;nbsp;&amp;#9989; Practitioner&lt;/p&gt; &lt;hr/&gt;&lt;p&gt;   You can use this endpoint to invite someone to become a Patient. You must specify either the new user&#x27;s email or phone number. When you call the endpoint, the person being invited will receive an email with the &lt;code&gt;confirmation_url&lt;/code&gt; or an SMS with the &lt;code&gt;passwordless_login_url&lt;/code&gt;, which they can use to confirm signup. &lt;/p&gt; &lt;p&gt;   One use case for the endpoint is to allow a current Patient to invite another person to become a Patient. In this scenario, the response to calling the endpoint will always be an empty body, and Capable will not specify whether the call was successful, to ensure data security. &lt;/p&gt; 
     * @param {Object} opts Optional parameters
     * @param {module:model/PatientsInviteBody} opts.body 
     * @param {module:api/PatientsApi~patientsInvitePostCallback} callback The callback function, accepting three arguments: error, data, response
     */
    patientsInvitePost(opts, callback) {
      opts = opts || {};
      let postBody = opts['body'];

      let pathParams = {
        
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = ['application/json'];
      let accepts = [];
      let returnType = null;

      return this.apiClient.callApi(
        '/patients/invite', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the patientsMeGet operation.
     * @callback moduleapi/PatientsApi~patientsMeGetCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Retrieve current Patient
     * &lt;h3&gt;   &amp;#128275; Access policy &lt;/h3&gt; &lt;p&gt;You can access this endpoint with the following token types:&lt;/p&gt; &lt;p&gt;&amp;#10060; &lt;s&gt;M2M&lt;/s&gt;&amp;nbsp;&amp;nbsp;&amp;nbsp;&amp;nbsp;&amp;#9989; Patient&amp;nbsp;&amp;nbsp;&amp;nbsp;&amp;nbsp;&amp;#10060; &lt;s&gt;Practitioner&lt;/s&gt;&lt;/p&gt; 
     * @param {module:api/PatientsApi~patientsMeGetCallback} callback The callback function, accepting three arguments: error, data, response
     */
    patientsMeGet(callback) {
      
      let postBody = null;

      let pathParams = {
        
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = [];
      let returnType = null;

      return this.apiClient.callApi(
        '/patients/me', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the patientsPost operation.
     * @callback moduleapi/PatientsApi~patientsPostCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Create a Patient
     * &lt;h3&gt;   &amp;#128275; Access policy &lt;/h3&gt; &lt;p&gt;You can access this endpoint with the following token types:&lt;/p&gt; &lt;p&gt;&amp;#9989; M2M&amp;nbsp;&amp;nbsp;&amp;nbsp;&amp;nbsp;&amp;#10060; &lt;s&gt;Patient&lt;/s&gt;&amp;nbsp;&amp;nbsp;&amp;nbsp;&amp;nbsp;&amp;#10060; &lt;s&gt;Practitioner&lt;/s&gt;&lt;/p&gt; 
     * @param {Object} opts Optional parameters
     * @param {module:model/PatientsBody} opts.body 
     * @param {module:api/PatientsApi~patientsPostCallback} callback The callback function, accepting three arguments: error, data, response
     */
    patientsPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['body'];

      let pathParams = {
        
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = ['application/json'];
      let accepts = [];
      let returnType = null;

      return this.apiClient.callApi(
        '/patients', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the patientsSearchGet operation.
     * @callback moduleapi/PatientsApi~patientsSearchGetCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Search patients by email
     * @param {String} query Email search term
     * @param {module:api/PatientsApi~patientsSearchGetCallback} callback The callback function, accepting three arguments: error, data, response
     */
    patientsSearchGet(query, callback) {
      
      let postBody = null;
      // verify the required parameter 'query' is set
      if (query === undefined || query === null) {
        throw new Error("Missing the required parameter 'query' when calling patientsSearchGet");
      }

      let pathParams = {
        
      };
      let queryParams = {
        'query': query
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = [];
      let returnType = null;

      return this.apiClient.callApi(
        '/patients/search', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

}
